import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Auth.css';

const RestablecerPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verificando, setVerificando] = useState(true);
  const [tokenValido, setTokenValido] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    verificarToken();
  }, [token]);

  const verificarToken = async () => {
    try {
      const API_URL = '/api';
      const response = await axios.get(`${API_URL}/password-reset/verificar/${token}`);

      if (response.data.valido) {
        setTokenValido(true);
        setEmail(response.data.email);
      } else {
        setTokenValido(false);
        setError('El enlace de recuperación es inválido o ha expirado');
      }
    } catch (err) {
      setTokenValido(false);
      setError(err.response?.data?.error || 'El enlace de recuperación es inválido o ha expirado');
    } finally {
      setVerificando(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);

    try {
      const API_URL = '/api';
      await axios.post(`${API_URL}/password-reset/restablecer`, {
        token,
        nueva_password: password
      });

      alert('Contraseña restablecida exitosamente');
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al restablecer contraseña');
    } finally {
      setLoading(false);
    }
  };

  if (verificando) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>AppContra</h1>
          <p style={{ textAlign: 'center', color: '#6b7280' }}>Verificando enlace...</p>
        </div>
      </div>
    );
  }

  if (!tokenValido) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>AppContra</h1>
          <h2>Enlace Inválido</h2>

          <div className="error-message">{error}</div>

          <p style={{ marginTop: '20px', color: '#6b7280', fontSize: '14px' }}>
            El enlace de recuperación puede haber expirado. Los enlaces son válidos por 1 hora.
          </p>

          <p className="auth-footer">
            <Link to="/solicitar-recuperacion">Solicitar nuevo enlace</Link>
            {' | '}
            <Link to="/login">Volver al inicio de sesión</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>AppContra</h1>
        <h2>Restablecer Contraseña</h2>

        <p style={{ marginBottom: '20px', color: '#6b7280', fontSize: '14px' }}>
          Ingresa tu nueva contraseña para <strong>{email}</strong>
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nueva Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="6"
              placeholder="Mínimo 6 caracteres"
            />
          </div>

          <div className="form-group">
            <label>Confirmar Contraseña</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength="6"
              placeholder="Repite tu contraseña"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Restableciendo...' : 'Restablecer Contraseña'}
          </button>
        </form>

        <p className="auth-footer">
          <Link to="/login">Volver al inicio de sesión</Link>
        </p>
      </div>
    </div>
  );
};

export default RestablecerPassword;
